import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/url-router/UrlRouterUIHelpers";

const initialUrlRoutersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  urlRouterForEdit: undefined,
  lastError: null,
  filters: initialFilter
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const urlRouterSlice = createSlice({
  name: "urlRouters",
  initialState: initialUrlRoutersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getUrlRouterById
    urlRouterFetched: (state, action) => {
      state.actionsLoading = false;
      state.urlRouterForEdit = action.payload.urlRouterForEdit;
      state.error = null;
    },
    // findUrlRouters
    urlRoutersFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // getAllUrlRouter
    urlRouterAllFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.all = action.payload.all;
    },
    // createUrlRouter
    urlRouterCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.urlRouter);
    },
    // updateUrlRouter
    urlRouterUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.urlRouter.id) {
          return action.payload.urlRouter;
        }
        return entity;
      });
    },
    urlRouterFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  },
});
